<template>
  <section :id="section.id">
    <div
      :class="[
        'container',
        section.is_visible ? 'fade-in' : 'fade-out',
      ]"
    >
      <div class="small-content text-center">
        <h2 class="section-title mb-8">
          {{ getContent('section_protocol_explanation.title') }}
        </h2>
        <div class="content-text">
          <p>
            {{ getContent('section_protocol_explanation.subtitle_paragraph_1_row_1') }}
            <br />
            {{ getContent('section_protocol_explanation.subtitle_paragraph_1_row_2') }}
          </p>
          <br />
          <p>
            {{ getContent('section_protocol_explanation.subtitle_paragraph_2') }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContentSectionProtocolExplanation',
  data: () => ({
    section: {
      id: contentSectionId.protocol_explanation,
      is_visible: true,
    },
  }),
  mounted() {
    this.section.is_visible = false
    initObserver(this.section)
  },
}
</script>
